import Route from "../config/RouteApi";
import axios from "axios";
import store from "../store/index";
import route from "../router/index";
import socket from "./Socket"
import { DEBUG } from "../../env";
export default class Api {
  routeApi = Route;
  async post(data, showLoader=true) {
    if(showLoader){
      store.dispatch("loader", true);  
    }
    
    let that = this;
    return new Promise((resolve, reject) => {
      // console.log("TOKEN", store.getters.token);
      axios.defaults.headers.common["Authorization"] = store.getters.token;
      axios.defaults.headers.common["Content-Type"] = "application/json";
      axios.defaults.headers.common["Accept"] = "application/json";

      let url = that.routeApi + data.url;
      let form = {};
      if (data.form) {
        let datos = data.data;
        for (let index in datos) {
          form[datos[index].tag] = datos[index].value;
        }
      } else {
        form = data.data;
      }
      // console.log("ROUTE POST >>>", url);
      // console.log("DATA POST >>>>", form);
      axios
        .post(url, form)
        .then(response => {
          if(showLoader){
            that.responseStatus(response, response.status);
          }
          resolve(response.data);
          return;
        })
        .catch(err => {
          that.responseStatus(err.response, err.response.status);
          reject(err);
          return;
        });
    });
  }

  async delete(data) {
    store.dispatch("loader", true);
    let that = this;
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common["Authorization"] = store.getters.token;
      axios.defaults.headers.common["Content-Type"] = "application/json";
      axios.defaults.headers.common["Accept"] = "application/json";

      // console.log('token',localStorage.token)
      let url = that.routeApi + data.url;
      //   console.log("ROUTE GET >>>", url);
      // console.log('DATA >>>>',data.data)
      axios
        .delete(url)
        .then(response => {
          store.dispatch("loader", false);
          
          resolve(response.data);
          return;
        })
        .catch(err => {
          store.dispatch("loader", false);
          that.responseStatus(err.response, err.response.status);
          reject(err);
          return;
        });
    });
  }

  async get(data, showLoader=true) {
    if(showLoader){
      store.dispatch("loader", true);
    }
    
    let that = this;
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common["Authorization"] = store.getters.token;
      axios.defaults.headers.common["Content-Type"] = "application/json";
      axios.defaults.headers.common["Accept"] = "application/json";

      // console.log('token',localStorage.token)
      let url = that.routeApi + data.url;
      //   console.log("ROUTE GET >>>", url);
      // console.log('DATA >>>>',data.data)
      axios
        .get(url)
        .then(response => {
          store.dispatch("loader", false);
          
          resolve(response.data);
          return;
        })
        .catch(err => {
          store.dispatch("loader", false);
          that.responseStatus(err.response, err.response.status);
          reject(err);
          return;
        });
    });
  }

  responseStatus(data, status) {
    // console.log('data',data)
    store.dispatch("loader", false);
    let text = data.data.message;
    let color = "";
    let messageTraking = "unknown"
    let dataUrl = null
    let redirect = false;
    let render = true;
    let emitSocket = true;
    switch (status) {
      case 401:
        color = "error";
        redirect = true;
        emitSocket = false;
        break;
      case 200:
        color = "success";
        text = "Accion realizada con exito";
        emitSocket = false;
        break;
      case 404:
        color = "warning";
        text = "Informacion no encontrada";
        dataUrl = data.data
        break;
      case 405:
        color = "warning";
        break;
      case 406:
        render = false;
        color = "info";
        emitSocket = false;
        for (let index in data.data) {
          store.dispatch("snackbar", {
            view: true,
            text: data.data[index],
            config: { color: color }
          });
        }

        break;
      case 422:
        color = "info";
        if (data.data.errors.token) {
          text = "El token es obligatorio";
        }
        if (data.data.errors.password) {
          if (data.data.errors.password[0] == "validation.confirmed") {
            text = "Las contraseñas no coinciden";
          }
          if (data.data.errors.password[0] == "validation.min.string") {
            text = "Las contraseña debe ser mayor a 5 caracteres";
          }
          if (data.data.errors.password[0] == "validation.required") {
            text = "Las contraseña es obligatorio";
          }
        }
        if (data.data.errors.email) {
          text = "El email es obligatorio";
        }
        break;
      case 500:
        color = "error";
        text = "Error del servidor";
        messageTraking = data.data.message;
        dataUrl = data.data
        break;
      default:
        (text = "Error no especificado"), (color = "error");
        break;
    }
    console.log(data)
    if (emitSocket && !DEBUG) {
      socket.sendError({
        type:'http',
        status : status,
        mode:'client',
        url:data.config.url,
        dataUrl:dataUrl,
        message:messageTraking
      })
    }
    if (render) {
      if (route.currentRoute.name != 'ReviewPass' && route.currentRoute.name != 'CargaArchivo' && route.currentRoute.name != 'CircuitoPreInscripcionv2' && route.currentRoute.name != 'CargaArchivoparams' && route.currentRoute.name!='Circuito') {
        store.dispatch("snackbar", {
          view: true,
          text: text,
          config: { color: color }
        });
      }

    }

    if (redirect) {
      setTimeout(() => {
        store.dispatch("token", "");
        store.dispatch("token", "");
        store.dispatch("user", {});
        store.dispatch("tieneBadge1", false)
        store.dispatch("tieneBadge2", false)
        store.dispatch("tieneBadge3", false)
        store.dispatch("porcentaje1", 0)
        store.dispatch("porcentaje2", 0)
        store.dispatch("porcentaje3", 0)
        store.dispatch("primeroIngreso", false)
        store.dispatch("apareceModalInicial", false)
        store.dispatch("carreraPrincipal", "")
        store.dispatch("imagenbs","")
        if (route.currentRoute.name != 'ReviewPass' && route.currentRoute.name != 'CargaArchivo' && route.currentRoute.name != 'CircuitoPreInscripcionv2' && route.currentRoute.name != 'CargaArchivoparams' && route.currentRoute.name!='Circuito') {
          route.replace({ name: "Login" }).catch(() => { });
        }

      }, 1000);
    }
  }
}
